export {
  Primitive,
  //
  Root,
  //
  dispatchDiscreteCustomEvent,
} from './Primitive';
export type { ComponentPropsWithoutRef, PrimitivePropsWithRef } from './Primitive';
